/* import __COLOCATED_TEMPLATE__ from './fin-followups.hbs'; */
/* RESPONSIBLE TEAM: team-messenger */

import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import type { FinSetupBehaviorSaveParams } from 'embercom/lib/operator/fin/types';
import { inject as service } from '@ember/service';
import type { FollowupOption } from './follow-up-options';
import type IntlService from 'ember-intl/services/intl';
import type Profile from 'embercom/models/ai-agent/profile';

interface Args {
  accordion: $TSFixMe;
  ruleset: $TSFixMe;
  partialSave: (params: FinSetupBehaviorSaveParams) => void;
  isReadOnly: boolean;
}

export default class FinFollowups extends Component<Args> {
  @service declare intl: IntlService;
  @tracked selectedOption: FollowupOption = this.behavior.followUpType;

  get selectedLabel() {
    let translationKey = 'operator.fin.setup.setup-and-go-live.fin-followups.followup-options.';

    switch (this.selectedOption) {
      case 'follow_up':
        translationKey += 'fin-follows-up';
        break;
      case 'follow_up_with_escalation':
        translationKey += 'fin-follows-up-handoff';
        break;
      case 'no_follow_up':
        translationKey += 'no-follow-up';
        break;
    }

    return this.intl.t(translationKey);
  }

  get ruleset() {
    return this.args.ruleset;
  }

  get behavior(): Profile {
    return this.ruleset.rulesetLinks.firstObject.object;
  }

  @action
  setSelectedOption(option: FollowupOption) {
    this.selectedOption = option;
  }

  @action
  async updateFollowupConfig() {
    this.args.partialSave({
      follow_up_type: this.selectedOption,
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Operator::Fin::Setup::Sections::FollowUp::FinFollowups': typeof FinFollowups;
    'operator/fin/setup/sections/follow-up/fin-followups': typeof FinFollowups;
  }
}
